import type { ReactElement } from 'react';
import type { TabId } from '../types.js';
import { ThemeDropdown } from './ThemeDropdown.js';
import { SettingsDropdown } from './SettingsDropdown.js';

export interface HeaderProps {
  onNavigate: (id: TabId) => void;
  onOpenMenu: () => void;
}

export function Header({ onNavigate, onOpenMenu }: HeaderProps): ReactElement {
  return (
    <header
      className="sticky top-0 z-10 flex items-center justify-between border-b px-4 py-3"
      style={{
        background: 'var(--bg-surface)',
        borderColor: 'var(--border)',
      }}
    >
      <div className="flex items-center gap-2">
        <button
          type="button"
          aria-label="Open menu"
          onClick={onOpenMenu}
          className="flex min-h-[48px] min-w-[48px] items-center justify-center rounded-md"
          style={{
            color: 'var(--text-main)',
            background: 'transparent',
          }}
          data-testid="header-menu-toggle"
        >
          <span aria-hidden="true" className="text-xl">
            ☰
          </span>
        </button>
        <div className="flex items-center gap-2 text-lg font-semibold">
          <span aria-hidden="true">👨‍🍳</span>
          <span style={{ color: 'var(--text-main)' }}>ChefCook</span>
        </div>
      </div>
      <div className="flex items-center gap-1">
        <ThemeDropdown />
        <SettingsDropdown onNavigate={onNavigate} />
      </div>
    </header>
  );
}
